<template>
  <div
    v-if="event.replay"
    class="relative grid aspect-[16/9] place-content-center overflow-hidden rounded-lg"
  >
    <app-image
      alt=""
      class="absolute h-full w-full object-cover"
      :src="event.replay.cover"
    />

    <div class="absolute inset-0 bg-black/15" />

    <event-replay-cta color="light" :event="event" size="lg" />
  </div>
</template>

<script lang="ts" setup>
import type { EventView } from "~/business-areas/event/composables/event-view.hook";

defineProps<{
  event: EventView;
}>();
</script>
